export default __webpack_public_path__ + "static/media/cvv.60eeacf5.svg";